import { render, staticRenderFns } from "./PassCardConfig.vue?vue&type=template&id=4204776a"
import script from "./PassCardConfig.vue?vue&type=script&lang=js"
export * from "./PassCardConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports